var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-gray-500 text-center text-3xl mb-10 font-serif"},[_c('small',[_vm._v(_vm._s(_vm.$t('ACCOUNT_PROBLEMS.ACCOUNT_BLOCKED.TITLE')))])]),_c('p',[_vm._v(" "+_vm._s(_vm.$t('ACCOUNT_PROBLEMS.ACCOUNT_BLOCKED.TEXT'))+" ")]),_c('div',{staticClass:"mt-10 text-center"},[_c('account-problem-logout-button')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }